<template>
  <div class="about">
    <div class="about_content_box">
      <div class="title">
        <img src="../../assets/about/about_title_text_1.png" alt />
      </div>
      <div class="second_title">
        <span class="before"></span>科学支撑中医临床、教学科研、健康养生
        <span class="after"></span>
      </div>
      <div class="about_content">
        <p>中医中药有着几千年的悠久历史，是中华民族几千年来同疾病斗争的经验结晶，历数千年而不衰。中医中药有与西医迥异的理论体系，而且有着丰富的学术内容。随着中医药被更多国家和地区的认可和推崇，口传心授的传承方式已远远满足不了现代社会对中医中药的需求。为了推进中医药在国际上的地位和影响力，唤起全世界对中医药自然疗法的认识，也为了方便国内外更多患者指导就医，我们特此创办了千年医典数据库。</p>
        <p>中医药学是中华民族灿烂文化的重要组成部分。几千年来为中华民族的繁荣昌盛做出了卓越的贡献，并以显著的疗效、浓郁的民族特色、独特的诊疗方法、系统的理论体系、浩瀚的文献史料，屹立于世界医学之林，成为人类医学宝库的共同财富。中医药学历数千年而不衰，显示了自身强大的生命力，它与现代医药共同构成了我国卫生事业，是中国医药卫生事业所具有的特色和优势。</p>
      </div>
      <div class="title" style="margin-top:53px;">
        <img src="../../assets/about/about_title_text_2.png" alt />
      </div>
      <div class="about_content">
        <img src="../../assets/about/img_01.png" alt align="right" style="margin-left:20px" />
        <p>
          <strong>《域外中医古籍丛书》</strong>系中日学者、日本中医古籍专家历时四十余年，先后对千余年来流存于日本的中医文献进行系统整理而成。丛书共计656册，分装47箱，所收中医古籍2376余种。
        </p>
        <p>从版本上分有刻本、抄本、稿本、铅印本。从版本跨越的时间来分包括中国宋、元、明、清历代中医典籍刻本、抄本，其中尤为珍贵的是国内罕见宋元刻本。日本历代和刻本中医典籍也是此套丛书一大特色，其中有日本翻刻的中医原文典籍，以及日文和刻本中医典籍。亦有日人著述阐发中医的文集等。</p>
        <p>从中医学广度上分此套丛书包涵有：中医医理、医药、内科、 外科、脏腑、经络、针灸、本草、方剂、病机、病症、诊法、治疗、 临床等。从深度上大到一流一派的理论阐发，小到一症一候、一 方一剂、一穴一脉等的临床施治。</p>
      </div>
      <div class="about_content" style="padding-bottom:43px;border-bottom:1px solid #e5e5e5;">
        <img src="../../assets/about/img_02.png" alt align="right" style="margin-left:20px" />
        <p>丛书构成如下：宋元中医珍善本系列、黄帝内经系列、伤寒论、 金匮要略系列、温病论系列、针灸系列、经络经穴书系列、难经集 注、针灸汉方诊断学系列、针灸汉方病证学系列、临床汉方系列、 临床和方系列、杂志复刻系列、医家全集系列、民间秘方等。此套珍贵的文献资料对中医版本学文献的研究、中医理论研究、中医经方验方的梳理、中医的临床诊断、中医临床针灸的实践、 中日中医临床理论、学术研究交流等方面均有重大理论研究与临 床实践意义。</p>
        <p>千年医典数据库由北京神黄科技股份有限公司编辑部组建而成，“神黄”寓意源于中医典籍基石— 《神农本草经》和《黄帝内经》。自成立以 来专注中医药传承创新平台开发与服务，是国家高新文化技术企业。多年来遍访海内 外，收集整理，专家甄别挑选，“神黄”已经建立起系统全面权威的中医药古籍文献 经典版本资源库，博大精深。本中心以影印珍本、善本、孤本中医古籍为主，同时编辑出版其他大型古籍文献暨中国博物学、中国历史学、中国民俗学、中国文献学等传统文化领域的出版物。</p>
        <div class="clear"></div>
      </div>
      <div class="about_content">
        <img src="../../assets/about/img_03.png" alt align="right" style="margin-left:20px" />
        <p>
          <strong>《中医十三经》</strong>由北京中医药大学钱超尘教授主编，全书遴选中医经典十三种，分三十六册， 由线装书局原版影印出版，全国各地新华书店 发行。
        </p>
        <p>丛书版本精良，多为坊间鲜见的宋、元、明代善本。丛书的书目经由国内外数十位界内专家学 者、临床名老中医讨论、甄选而成。并将日、 韩所藏诸多珍本。所选底本，经多位业内专家论证，力求所选底本为善中之善者，且对每部入选版本进行文献考证，独立成册。主编为各书所作版本题解，提纲契领，理清经典之脉络， 尤便后学。《中医十三经》包括《黄帝内经》、《神农本 草经》、《难经》、《金匮要略》、《伤寒论》、《脉经》、《黄帝三部针灸甲乙经》、《重刊巢氏诸病源候总论 》、《备急千金要方》、《千金翼方》、《黄帝内经太素》( 附《黄帝内经明堂类成》)、《唐王焘先生外台秘要方》、《本草纲目》。</p>
      </div>
      <div class="about_content about_img">
        <img src="../../assets/about/img_04.png" alt style="margin-right:9px;" />
        <img src="../../assets/about/img_05.png" alt style="margin-right:8px;" />
        <img src="../../assets/about/img_06.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
	metaInfo: {
		title: "千年医典数据库-科学支撑中医临床、教学科研、健康养生",
    meta: [
		{ name: "keywords", content: "中医中药,中医十三经,域外中医古籍丛书" },
      { name: "description", content: "关于千年医典数据库的介绍" }
    ]
  },
  created(){
	//    const alocation= sessionStorage.getItem("hashLocation");//缓存中获取当前页面的路由名称
	const hashLocation = this.$route.path
	//   const newLocation = hashLocation.split("#/")[1];
	const url = "https://www.kanguji.com"+hashLocation
      this.$matomo.setCustomUrl(url);//覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
      // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称

  }
};
</script>

<style scoped lang="scss" type="text/css">
.about {
  border: 1px solid transparent;
  background: url(../../assets/public/bg1.png);
  .swiper-container {
    z-index: 0;
    img {
      width: 100%;
    }
  }
  .about_content_box {
    width: 900px;
    background-color: #fff;
    margin: 40px auto 40px;
    padding: 50px;
    box-shadow: 0 0 10px #eaeaea;
    .title {
      text-align: center;
    }
    .second_title {
      text-align: center;
      font-size: 14px;
      color: #333;
      position: relative;
      line-height: 34px;
      span {
        display: inline-block;
        width: 300px;
        height: 1px;
        border-top: 1px solid #bfbfbf;
        position: absolute;
        top: 50%;
      }
      .before {
        left: 0;
      }
      .after {
        right: 0;
      }
    }
    .about_content {
      /*border: 1px solid red;*/
      font-size: 14px;
      color: #333;
      margin-top: 23px;
      p {
        text-indent: 1em;
        line-height: 2;
        margin-top: 10px;
        font-family: PingFangSC-Light, sans-serif;
        font-weight: 300;
        /*letter-spacing:2px;*/
        strong {
          font-size: 18px;
          font-family: PingFangSC-Regular, sans-serif;
          font-weight: 300;
        }
      }
    }

    /*.about_img{
				border: 1px solid yellow;
				display: flex;
				justify-content: space-between;
				img{
					display: block;
				}
			}*/

    .btn_box {
      text-align: center;
      button {
        width: 220px;
        height: 44px;
        border-radius: 8px;
        font-size: 18px;
        font-weight: normal;
        color: #fff;
        text-align: center;
        line-height: 44px;
        background-color: #4866ae;
        border: none;
        margin-top: 38px;
        font-family: PingFangSC-medium, sans-serif;
        outline: none;
        img {
          vertical-align: middle;
          margin-top: -3px;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/about.vue